import Base64 from 'assets/js/util/base64';

/**
 * It should show the switch editor button if the user is not a workspace user
 * unless the user's email ends with @desygner.com
 * @returns {boolean}
 */
export function shouldShowSwitchEditorButton () {
  const encodedEmail = INKIVE.C.USER.email;
  if (!encodedEmail) return false;

  const userEmail = Base64.decode(encodedEmail);

  // const isDesygnerProject = INKIVE.Helpers.isDesygnerProject();
  const isAllowedWorkspace = INKIVE.C.SHOW_NEW_EDITOR;
  const isDesygnerStaff = /@(desygner|webrand|fluer)\.com$/.test(userEmail);

  return [
    // isDesygnerProject,
    isDesygnerStaff,
    isAllowedWorkspace
  ].some(Boolean);
}
